// 생기부 "참고 예시 문장" — 종류 스코프는 백엔드 VALID_SCOPES와 동일
export const STYLE_CATEGORY_SCOPES = ['행동발달', '교과', '교과_고등', '창체', '동아리', '진로'];
export const STYLE_EXAMPLE_MAX_CHARS = 300;
// 백엔드 MIN_EXAMPLE_CHARS 와 동일 — 이보다 짧은 항목은 서버가 저장하지 않는다
export const STYLE_EXAMPLE_MIN_CHARS = 10;
export const STYLE_EXAMPLE_PREVIEW_CHARS = 40;
// 백엔드 MAX_EXAMPLES_PER_SCOPE / MAX_EXAMPLES_GLOBAL 과 동일 (2026-09-12 20/30 → 100/150 상향)
export const STYLE_EXAMPLE_LIMIT_DEFAULT = 100;
export const STYLE_EXAMPLE_LIMIT_GLOBAL = 150;

export const STYLE_EXAMPLE_COPY = {
  header: '참고 예시 문장 (선택)',
  explainWhy: '예시는 문체·구조 참고용이에요. AI가 그대로 옮겨 쓰지 않도록 막아 두었어요.',
  placeholder: '잘 쓴 문장을 여러 개 붙여넣어도 돼요 · 줄바꿈이나 빈 줄로 나눠요',
  addButton: '추가',
  addHint: 'Enter를 누르거나 추가를 눌러 목록에 넣어요 · 줄바꿈은 Shift+Enter',
  itemLabel: '예시 문장',
  overLimitHint: '300자로 줄여주세요',
  tooShortHint: '10자 이상 써주세요 · 짧은 문장은 저장되지 않아요',
  proOnly: 'PRO에서 쓸 수 있어요',
  saveButton: '예시로 저장',
  savedToast: '참고 예시로 저장했어요',
  savedAction: '내 스타일 보기',
  duplicateToast: '이미 저장된 예시예요',
  truncatedToast: '앞부분 300자만 저장했어요',
};

export function mapSaenggibuCategoryToStyleScope(category, hint) {
  const candidates = [category, hint];
  for (const value of candidates) {
    if (STYLE_CATEGORY_SCOPES.includes(value)) return value;
  }
  return 'global';
}

export const FREE_STYLE_EXAMPLE_LIMIT = 20;

export function getStyleExamplesLimit(scope, profileLimit) {
  const parsed = Number(profileLimit);
  if (Number.isFinite(parsed) && parsed > 0) return parsed;
  return scope === 'global' ? STYLE_EXAMPLE_LIMIT_GLOBAL : STYLE_EXAMPLE_LIMIT_DEFAULT;
}

export function splitReferenceExamples(raw) {
  const text = String(raw || '').replace(/\r\n/g, '\n').trim();
  if (!text) return [];
  const byBlank = text.split(/\n\s*\n/).map((part) => part.trim()).filter(Boolean);
  if (byBlank.length > 1) return byBlank;
  return text.split('\n').map((part) => part.trim()).filter(Boolean);
}

export function previewExampleText(text, max = STYLE_EXAMPLE_PREVIEW_CHARS) {
  const value = String(text || '').replace(/\s+/g, ' ').trim();
  if (value.length <= max) return value;
  return `${value.slice(0, max)}…`;
}

// 붙여넣기/입력 원문 → 모달 scope를 종류로 갖는 새 항목들 (항목별 종류 선택은 없다: 모달이 이미 종류별이다)
export function createStyleExampleItems(raw, editScope) {
  return splitReferenceExamples(raw).map((text, index) => ({
    localKey: `draft-${Date.now()}-${index}-${Math.random().toString(36).slice(2, 7)}`,
    text,
    category: editScope === 'global' ? null : editScope,
    source: 'manual',
  }));
}

// 저장 시점에 아직 목록에 넣지 않은 입력(draft)을 합친다.
// blur 타이밍에 의존하지 않기 위한 단일 진실원 — 타이핑 직후 저장 버튼을 눌러도 예시가 빠지지 않는다.
export function mergePendingStyleExampleDraft({ items = [], draft = '', editScope } = {}) {
  // 이미 목록에 있는 문장과 글자 그대로 같은 초안은 다시 넣지 않는다 (서버 dedup 이전에 이중 전송 방지)
  const existingTexts = new Set(
    (Array.isArray(items) ? items : []).map((item) => String(item?.text || '').trim()).filter(Boolean)
  );
  const pending = String(draft || '').trim()
    ? createStyleExampleItems(draft, editScope).filter((item) => !existingTexts.has(String(item.text || '').trim()))
    : [];
  return {
    items: pending.length > 0 ? [...items, ...pending] : items,
    pendingCount: pending.length,
  };
}

export function buildStyleExamplePutItems(items) {
  return (Array.isArray(items) ? items : [])
    .map((item) => ({
      ...(item?.id ? { id: item.id } : {}),
      text: String(item?.text || '').trim(),
      category: item?.category || null,
      source: item?.source || 'manual',
    }))
    .filter((item) => item.text);
}

export function buildStyleProfileSavePayload({
  instructions = '',
  styleSpec = {},
  ruleSummary = [],
  sourceTexts = [],
  analysisModel = '',
  examplesTouched = false,
  exampleItems = [],
} = {}) {
  const payload = {
    enabled: true,
    instructions: String(instructions || '').trim(),
    style_spec: styleSpec,
    rule_summary: ruleSummary,
  };
  if (sourceTexts.length > 0) payload.source_texts = sourceTexts;
  if (analysisModel) payload.analysis_model = analysisModel;
  if (examplesTouched) {
    payload.examples = buildStyleExamplePutItems(exampleItems);
  }
  return payload;
}

export function styleExampleRejectionFromError(error) {
  const message = String(error?.detail || error?.message || '');
  const rejectedIndex = error?.error?.index;
  if (error?.error?.code === 'style_example_rejected' || rejectedIndex) {
    return { index: rejectedIndex, detail: message };
  }
  return null;
}
